import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MainConfiguration, MenuConfiguration } from 'src/business/models/main-configuration.model';
import { LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { ImageUtil } from 'src/layout/media/image.util';
import { MediaModule } from 'src/layout/media/media.module';
import { ContentCacheUtils } from 'src/utils/storage.util';

@Component({
    selector: 'app-commerce-header',
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule, MediaModule],
    templateUrl: './commerce-header.component.html',
    styleUrl: './commerce-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommerceHeaderComponent {
    logoUrl: URL;
    system: MainConfiguration;
    mobileLogoUrl: URL;
    menu: MenuConfiguration;
    phone: string;
    constructor( @Inject(LANGUAGE)
    public catalog: string) {
        this.system = ContentCacheUtils.system<MainConfiguration>();
        this.logoUrl = ImageUtil.getURL(this.system?.theme?.logo, { height: 68, width: 155, });
        this.mobileLogoUrl = ImageUtil.getURL(this.system?.theme?.logoMobile ?? this.system?.theme?.logo, { height: 50, width: 120, });
        this.menu = ContentCacheUtils.menu<MenuConfiguration>();
        this.phone = this.menu.store.phone;
    }
}
